export const aiAgentTasksPath = ({ appSlug }: { appSlug: string }) => `/apps/${appSlug}/ai_agent_tasks`;

export const aiAgentTaskPath = ({ appSlug, taskId }: { appSlug: string; taskId: string }) =>
  `${aiAgentTasksPath({ appSlug })}/${taskId}`;

export const abortAIAgentTaskPath = ({ appSlug, taskId }: { appSlug: string; taskId: string }) =>
  `${aiAgentTaskPath({ appSlug, taskId })}/abort`;
